import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './components/appviews/home/home.component';
import { QuestionComponent } from './components/appviews/Question/question/question.component';

const routes: Routes = [

    { path: '', component: HomeComponent },
    { path: 'question', component: QuestionComponent }

];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
